import { render, staticRenderFns } from "./SalesorderLogList.vue?vue&type=template&id=5cbca3a5&scoped=true&"
import script from "./SalesorderLogList.vue?vue&type=script&lang=js&"
export * from "./SalesorderLogList.vue?vue&type=script&lang=js&"
import style0 from "./SalesorderLogList.vue?vue&type=style&index=0&id=5cbca3a5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbca3a5",
  null
  
)

export default component.exports